// Auto-extracted from LangContext.jsx — single source of truth for PT translations.
// Edit this file to update wording. Keys must stay in sync across active locales (see ACTIVE_LANGS).
/* eslint-disable */
const dict = {
  app_tagline: 'O futuro dos playbooks de basquete',
  nav_dashboard: 'Painel', nav_playbook: 'Playbook', nav_editor: 'Editor', nav_roster: 'Elenco',
  nav_ai: 'IA Coach', nav_live: 'Jogo ao Vivo', nav_simulator: 'Simulador', nav_academy: 'Academia',
  nav_invitations: 'Convites', nav_admin: 'Admin', nav_pricing: 'Planos',
  nav_marketplace: 'Marketplace', nav_profile: 'Meu Perfil', nav_notifications: 'Notificações', nav_achievements: 'Conquistas',
  nav_tactile: 'Tátil', mob_market: 'Mercado', mob_ia: 'IA',
  login: 'Entrar', register: 'Cadastrar', logout: 'Sair', email: 'Email', password: 'Senha',
  name: 'Nome', role: 'Função', coach: 'Treinador', player: 'Jogador', or: 'ou',
  welcome_back: 'Bem-vindo de volta', create_account: 'Criar conta',
  plays: 'Jogadas', total_plays: 'Total de jogadas', active_players: 'Jogadores ativos',
  success_rate: 'Taxa de êxito', ai_sessions: 'Sessões IA',
  search: 'Buscar...', all_categories: 'Todas categorias',
  cat_man: 'vs Homem', cat_zone: 'vs Zona', cat_ato: 'ATO', cat_blob: 'BLOB', cat_slob: 'SLOB', cat_endgame: 'Final',
  create_play: 'Criar jogada', save: 'Salvar', cancel: 'Cancelar', edit: 'Editar', delete: 'Excluir',
  upload_photo: 'Foto', add_player: 'Adicionar',
  height: 'Altura', weight: 'Peso', number: 'Número', position: 'Posição',
  dominant_hand: 'Mão dominante', strength: 'Força', weakness: 'Fraqueza', ideal_role: 'Papel ideal',
  generate_link: 'Gerar convite', copy_link: 'Copiar', copied: 'Copiado',
  chat_placeholder: 'Pergunte à IA...',
  send: 'Enviar', generate_play: 'Gerar jogada', recommend_plays: 'Recomendar',
  predict_success: 'Prever',
  defense: 'Defesa', moment: 'Momento', recommend: 'Recomendar',
  step: 'Passo', steps: 'passos', play: 'Tocar', stop: 'Parar',
  pause: 'Pausar', prev: 'Ant.', next: 'Próx.', loop_label: 'Loop', off_label: 'Off',
  worked: '✔ Funcionou', didnt_work: '✕ Não funcionou',
  coach_premium: 'Coach Premium', player_premium: 'Player Premium', academy: 'Academia',
  month: 'mês', subscribe: 'Assinar',
  hello: 'Olá', loading: 'Carregando...', view_all: 'Ver tudo', back: 'Voltar', close: 'Fechar', confirm: 'Confirmar',
  language: 'Idioma', settings: 'Configurações', not_found: 'Não encontrada',
  top_plays: 'Top jogadas por taxa de êxito', distribution: 'Distribuição', open_ai_coach: 'Abrir IA Coach',
  my_roster: 'Meu elenco', my_publications: 'Minhas Publicações', no_plays_yet: 'Você ainda não criou jogadas próprias',
  no_invitations_yet: 'Você ainda não gerou convites', go_to: 'Ir para', go_to_editor: 'Vá ao Editor',
  dashboard_subtitle: 'Painel de controle do seu time', greeting_morning: 'Bom dia',
  privacy_policy: 'Política de privacidade', terms_of_service: 'Termos do serviço',
  error_generic: 'Erro', invalid_credentials: 'Credenciais inválidas',
  have_account: 'Já tem uma conta?', no_account: 'Ainda não tem conta?',
  invites_subtitle: 'Links curtos com seu domínio e métricas de cliques/inscrições.',
  invite_label: 'Etiqueta', invite_label_placeholder: 'Time principal',
  invite_custom_slug: 'Slug personalizado (opcional)',
  voice: 'Voz', muted: 'Mudo',
  voice_on_hint: 'Narração ativada (clique para silenciar)',
  voice_off_hint: 'Ativar narração por voz',
  loop_on_hint: 'Repetir ativado',
  loop_off_hint: 'Repetir desativado',
  translating: 'Traduzindo...',
  show_as: 'Mostrar como:', photo: 'Foto', initials: 'Iniciais',
  description_label: 'Descrição', works_against: 'Funciona contra',
  listen_narration: 'Ouvir narração', tactical_simulator: 'Simulador Tático',
  ai_prediction: 'Previsão IA', export_share: 'Exportar e compartilhar',
  image_label: 'Imagem', share_whatsapp_btn: 'Compartilhar via WhatsApp', generating_dots: 'Gerando…',
  delete_confirm: 'Excluir esta jogada?', deleted: 'Excluída',
  pdf_generated: 'PDF gerado', image_downloaded: 'Imagem baixada',
  frames_not_ready: 'Frames não prontos, tente de novo',
  share_error: 'Erro ao compartilhar', image_export_error: 'Erro ao exportar imagem',
  pdf_export_error: 'Erro ao exportar PDF', prediction_error: 'Erro de previsão IA',
  feedback_success_yes: 'Marcada como bem-sucedida', feedback_success_no: 'Marcada como falha',
  feedback_error: 'Erro de feedback', translation_error: 'Erro de tradução',
  cached_translation: 'Tradução em cache', translated_by_ai: 'Traduzida por IA',
  translated_to: 'Traduzida para', translate_with_ai: 'Traduzir com IA',
  whatsapp_open_attach: 'WhatsApp aberto: anexe a imagem baixada',
  reviews_title: 'Avaliações', your_review: 'Sua avaliação', publish_review: 'Publicar',
  update_review: 'Atualizar',
  review_placeholder: 'Opcional: conte aos outros coaches o que achou...',
  only_buyers_review: 'Só coaches que compraram podem avaliar.',
  no_reviews_yet: 'Sem avaliações ainda. Seja o primeiro.',
  choose_star: 'Escolha pelo menos 1 estrela', review_sent: 'Avaliação enviada',
  must_buy_review: 'Você precisa comprar esta jogada para avaliar',
  review_singular: 'avaliação', review_plural: 'avaliações',
  editor_title: 'Play Creator Pro',
  editor_subtitle: 'Compatível com caneta tátil, dedo e mouse. Selecione "Lápis livre" para desenhar.',
  blank_board: 'Lousa em branco', templates: 'Modelos', preview_label: 'Pré-visualização',
  play_name: 'Nome', play_description: 'Descrição',
  category: 'Categoria', difficulty: 'Dificuldade',
  beginner: 'Iniciante', intermediate: 'Intermediário', advanced: 'Avançado',
  pencil_free: 'Lápis livre',
  add_offense: '+Ataque', add_defense: '+Defesa',
  steps_title: 'Passos', add_step: 'Adicionar', step_description: 'Descrição do passo',
  speed: 'Velocidade', delay_exit: '⏱ Atraso na saída',
  assign_player_circle: 'Atribuir jogador ao círculo',
  quick_player_selection: 'Seleção rápida de jogadores',
  animation_preview: 'Pré-visualização com animação',
  load_template_title: 'Carregar template',
  export_pdf_title: 'Exportar para PDF',
  export_png_title: 'Baixar como imagem',
  share_whatsapp_title: 'Compartilhar pelo WhatsApp',
  clear_text: 'Limpar', unassigned: 'Sem atribuição',
  double_click_assign: 'Clique duplo num círculo abre este seletor. Foto + número + nome aparecem no token.',
  route_timing: 'Timing das rotas',
  route_timing_desc: 'Velocidade e atraso de cada jogador para coreografar pick&roll, back-door, double screen…',
  my_roster_quick: 'Meu elenco — toque rápido',
  players_count: 'jogadores',
  no_roster_yet_label: 'Sem jogadores ainda. Adicione em',
  no_roster_yet_label_after: 'para seleção rápida.',
  quick_add_hint: 'Toque num jogador e ele aparece instantaneamente. Toque duplo num círculo para reatribuir.',
  on_court_badge: 'EM QUADRA', tips_label: 'Dicas',
  tip_offense_defense_a: 'toque a quadra para adicionar um círculo genérico.',
  tip_pencil_a: 'desenhe a',
  tip_pencil_b: 'rota do jogador',
  tip_pencil_c: 'partindo do círculo dele e o sistema adicionará o próximo passo. Curvas soltas ficam como anotação.',
  tip_double_tap: 'Toque duplo em qualquer círculo para reatribuí-lo a um jogador do elenco.',
  no_name: 'Sem nome', my_new_play: 'Minha nova jogada', step_default_desc: 'Passo',
  move_players: 'Mover jogadores', arrow_move: 'Seta movimento',
  pass_tool: 'Passe', dribble_tool: 'Drible', screen_tool: 'Cortina', eraser_tool: 'Apagar',
  saved_ok: 'Salvo', save_error_msg: 'Erro ao salvar',
  ai_hero_title: 'Oi, sou seu IA Coach',
  ai_hero_subtitle: 'Peça-me jogadas, otimizações, previsões ou estratégias.',
  ai_powered_by: 'Powered by PlayMaster IA',
  ai_quick_1_label: 'Crie uma jogada contra zona 2-3',
  ai_quick_2_label: 'Recomende jogadas ATO vs homem',
  ai_quick_3_label: 'Otimize Horns Flare',
  ai_quick_1_prompt: 'Desenhe uma jogada nova para atacar defesa em zona 2-3. Explique os 3 passos-chave e por que funciona.',
  ai_quick_2_prompt: 'Recomende as 3 melhores jogadas ATO (after time-out) contra defesa homem-a-homem. Justifique.',
  ai_quick_3_prompt: 'Tenho a jogada Horns Flare. Como otimizar o spacing e os ângulos de cortina para torná-la mais letal contra trocas?',
  ai_connection_error: 'Erro de conexão IA',
  academy_title: 'Academia',
  academy_subtitle: 'Conceitos táticos, leitura de jogo e fundamentos. Toque numa lição para ver tutoriais curados no YouTube.',
  academy_will_open_youtube: 'Abriremos o YouTube com tutoriais curados sobre este tema.',
  academy_watch_youtube: 'Ver tutoriais no YouTube',
  academy_coming_soon: 'Em breve: lições nativas gravadas por treinadores de elite.',
  academy_lesson_1_title: 'Spacing: como abrir a quadra',
  academy_lesson_2_title: 'Como atacar a zona 2-3',
  academy_lesson_3_title: 'Defender Pick & Roll: drop coverage vs switch',
  academy_lesson_4_title: 'Leitura do jogo: quando mudar o ritmo',
  academy_lesson_5_title: 'Execução da Horns Action',
  academy_lesson_6_title: 'BLOB e SLOB em momentos decisivos',
  academy_cat_fundamentals: 'Fundamentos',
  academy_cat_vs_zone: 'Vs Zona',
  academy_cat_defense: 'Defesa',
  academy_cat_iq: 'QI',
  academy_cat_systems: 'Sistemas',
  academy_cat_ato_blob: 'ATO/BLOB',
  pricing_h1: 'Eleve seu jogo', pricing_subtitle: 'Escolha o plano que se adapta ao seu coaching.',
  plan_most_popular: 'Mais popular', payments_mocked: 'MOCKED · Os pagamentos serão integrados com Stripe na próxima versão.',
  feat_playbook_full: 'Playbook completo (100 jogadas)',
  feat_advanced_editor: 'Editor avançado',
  feat_unlimited_roster: 'Elenco ilimitado',
  feat_50_ai: '50 sessões IA/mês',
  feat_unlimited_invites: 'Convites ilimitados',
  feat_global_plays: 'Acesso a jogadas globais',
  feat_didactic_photos: 'Vista didática com suas fotos',
  feat_personal_ai_coach: 'IA Coach pessoal',
  feat_individual_stats: 'Estatísticas individuais',
  feat_academy_mode: 'Modo academia',
  feat_100_players: 'Até 100 jogadores',
  feat_multi_coach: 'Multi-coach',
  feat_unlimited_ai: 'IA sem limite',
  feat_personal_branding: 'Branding personalizado',
  feat_priority_support: 'Suporte prioritário',
  live_h1: 'Modo Jogo ao Vivo',
  live_subtitle: 'Selecione a defesa rival e o momento; a IA recomenda 3 jogadas.',
  live_voice_on: 'Voz ativada — Modo Jogo', live_voice_off: 'Ativar narração por voz',
  live_voice_extra: 'Cada jogada será lida em voz alta passo a passo.',
  live_defense_label: 'Defesa:', live_moment_label: 'Momento:',
  live_justification: 'Justificativa IA', live_see_detail: 'Ver detalhe',
  def_man: 'vs Homem', def_zone_2_3: 'vs Zona 2-3', def_zone_3_2: 'vs Zona 3-2',
  def_zone_1_3_1: 'vs Zona 1-3-1', def_switch: 'vs Switch', def_press: 'vs Press',
  moment_half_court: 'Meia-quadra', moment_ato: 'After Time-out (ATO)',
  moment_blob: 'BLOB (Linha de fundo)', moment_slob: 'SLOB (Lateral)', moment_endgame: 'Final de jogo',
  marketplace_seller_blurb: 'você fica com 85% de cada venda. Preço: US$ 0,99 – US$ 99,99.',
  profile_eyebrow: 'Perfil', profile_h1: 'Meu Perfil de Coach',
  profile_player_h1: 'Meu Perfil de Jogador',
  profile_player_subtitle: 'Seu coach vê estas mesmas informações no Roster.',
  profile_player_photo_help: 'Sua foto aparecerá no quadro tático quando o coach atribuir você a uma jogada.',
  elite_verified_badge: 'Coach Élite Verificado', identity_section: 'Identidade',
  no_photo: 'SEM FOTO', upload_photo_btn: 'Enviar foto',
  photo_help: 'Sua foto e credenciais são a primeira coisa que os compradores verão. Seja profissional.',
  field_display_name: 'Nome público', field_team: 'Time', field_country: 'País',
  field_credentials: 'Credenciais (ex. Head Coach · 10 anos · Liga ACB)',
  field_twitter: 'Twitter / X (@usuario)', field_instagram: 'Instagram (@usuario)',
  field_website: 'Site', field_bio: 'Bio (conte à comunidade que tipo de coach você é)',
  save_profile_btn: 'Salvar perfil', elite_status: 'Status Élite',
  verified_state: 'VERIFICADO',
  elite_active_text: 'Sua conta é élite. Suas jogadas são visíveis no Marketplace.',
  elite_since: 'Desde:', view_my_store: 'Ver minha loja',
  not_elite_yet: 'Você ainda não é Coach Élite. Solicite verificação para vender jogadas no Marketplace.',
  requirements_label: 'Requisitos:',
  req_bio_photo: 'Bio + foto profissional', req_credentials: 'Credenciais verificáveis',
  req_5_plays: 'Mín. 5 jogadas próprias criadas',
  request_verification: 'Solicitar verificação (admin only na v1)',
  my_achievements: 'Minhas Conquistas', no_achievements: 'Você ainda não desbloqueou conquistas.',
  publish_in_marketplace: 'Publicar no Marketplace',
  unpublish_from_marketplace: 'Remover do Marketplace',
  photo_uploaded: 'Foto enviada', upload_error: 'Erro no envio',
  profile_saved: 'Perfil salvo', play_published: 'Jogada publicada no marketplace',
  play_unpublished: 'Removida do marketplace',
  price_prompt: 'Preço (USD, entre 0,99 e 99,99)',
  sale_blurb_prompt: 'Descrição curta de venda:', purchased_badge: '(Comprada)',
  landing_get_started: 'Começar', landing_install_app: 'Instalar app',
  landing_hero_subtitle: 'O primeiro playbook inteligente projetado para treinadores de basquete. Desenhe, simule e compartilhe jogadas com IA.',
  landing_feature_editor: 'Editor visual', landing_feature_editor_desc: 'Desenhe jogadas táteis com o dedo ou caneta. Animações automáticas.',
  landing_feature_ai: 'IA Coach', landing_feature_ai_desc: 'Gere jogadas, recomende contra qualquer defesa, preveja sucesso.',
  landing_feature_share: 'Compartilhamento fácil', landing_feature_share_desc: 'Exporte PDF, compartilhe pelo WhatsApp com animações reais.',
  landing_install_short: 'Instalar',
  landing_hero_h1_a: 'O futuro dos', landing_hero_h1_b: 'Playbooks de Basquete',
  landing_hero_para: '100 jogadas profissionais, editor visual com fotos reais, IA generativa e preditiva, sistema de elenco e convites. Tudo em um ecossistema para treinadores, jogadores e academias.',
  landing_stat_plays: 'Jogadas', landing_stat_languages: 'Idiomas', landing_stat_coach_24: 'Coach 24/7',
  landing_live_preview: 'Pré-visualização ao vivo',
  landing_cap_eyebrow: 'Capacidades',
  landing_cap_h1_a: 'Um ecossistema completo', landing_cap_h1_b: 'para o basquete de elite',
  landing_f_playbook_t: 'Playbook Global', landing_f_playbook_d: '100 jogadas profissionais classificadas por Homem, Zona, ATO, BLOB, SLOB e Final de jogo, com animação passo a passo.',
  landing_f_ai_t: 'IA Coach', landing_f_ai_d: 'Gera novas jogadas, otimiza as existentes e prevê a probabilidade de sucesso. Recomenda em jogo ao vivo.',
  landing_f_roster_t: 'Elenco com Fotos', landing_f_roster_d: 'Envie fotos reais e crie fichas técnicas. Arraste seus jogadores para a quadra para jogadas 100% didáticas.',
  landing_f_langs_t: '6 Idiomas', landing_f_langs_d: 'Espanhol, Inglês, Francês, Português, Mandarim e Árabe — incluindo suporte RTL completo.',
  landing_f_live_t: 'Modo Jogo', landing_f_live_d: 'Selecione a defesa rival e o momento; a IA recomenda 3 jogadas instantâneas com justificativa tática.',
  landing_f_editor_t: 'Editor Visual', landing_f_editor_d: 'Quadra NBA, ferramentas flutuantes, desenho de movimentos, cortinas, cortes e múltiplos passos.',
  landing_cta_h1: 'Pronto para revolucionar seu quadro?', landing_cta_demo: 'Coach demo:',
  landing_cta_btn: 'Comece grátis', contact: 'Contato',
  achievements_eyebrow: 'Conquistas', achievements_h1: 'Minhas Conquistas',
  achievements_subtitle_a: 'Desbloqueie badges usando o app.', achievements_subtitle_b: 'desbloqueados.',
  achievements_progress: 'Progresso', achievements_latest: 'Últimas conquistas desbloqueadas',
  achievements_no_data: 'Sem dados.', achievements_no_yet: 'Comece a usar o app!',
  cat_creation: 'Criação', cat_roster_t: 'Elenco', cat_sales: 'Marketplace (Vendedor)',
  cat_buying: 'Marketplace (Comprador)', cat_quality: 'Qualidade', cat_status: 'Status', cat_ai: 'IA',
  tier_bronze: 'BRONZE', tier_silver: 'PRATA', tier_gold: 'OURO', tier_elite: 'ELITE',
  no_badges_yet: 'Sem conquistas ainda.',
  notifications_eyebrow: 'Notificações', notifications_h1: 'Centro de notificações',
  notif_enable_push: 'Ativar Push', notif_test: 'Test', notif_disable_push: 'Desativar push',
  notif_mark_all: 'Marcar todas', notif_empty: 'Sem notificações ainda.',
  notif_marked_all: 'Todas marcadas como lidas',
  notif_push_on: 'Push ativado. Avisaremos você mesmo se fechar o app.',
  notif_push_off: 'Push desativado', notif_push_error: 'Não foi possível ativar',
  notif_test_sent: 'Push test enviado', notif_test_error: 'Erro enviando test',
  devices: 'dispositivo', devices_plural: 'dispositivos',
  market_h1: 'Playbooks de Elite',
  market_subtitle: 'Compre jogadas criadas por coaches verificados. Cada compra é uma cópia pessoal no seu playbook.',
  market_publish_my_play: 'Publicar minha jogada',
  market_publish_my_play_title: 'Publique sua jogada no marketplace',
  market_banner_title: 'Você é coach? Compartilhe e venda seu sistema',
  market_banner_body: 'Publique suas jogadas com animação, rotas e velocidades. Defina seu preço entre US$ 0,99 e US$ 99,99. Você fica com 85% de cada venda.',
  market_banner_start: 'Começar →',
  market_tab_listings: 'Jogadas à venda',
  market_tab_coaches: 'Coaches Elite',
  market_tab_leaderboard: 'Ranking · Coach do Mês',
  market_sort_popular: 'Popular',
  market_sort_recent: 'Recentes',
  market_sort_price_asc: 'Preço ↑',
  market_sort_price_desc: 'Preço ↓',
  market_cat_all: 'Todas',
  market_empty: 'Sem jogadas à venda nesta categoria ainda.',
  market_sales: 'vendas',
  market_success: 'êxito',
  market_students: 'estudantes',
  market_plays_count: 'jogadas',
  market_verified_elite: 'Elite Verificado',
  roster_h1: 'Elenco',
  roster_player_updated: 'Jogador atualizado',
  roster_player_added: 'Jogador adicionado',
  roster_save_error: 'Erro ao salvar',
  roster_delete_confirm: 'Excluir jogador? (Ele será removido permanentemente do time.)',
  roster_block_confirm: 'Bloquear este jogador? Ele deixará de fazer parte do time e não verá mais suas jogadas.',
  roster_unblock_confirm: 'Desbloquear este jogador? Ele voltará a ter acesso às suas jogadas.',
  roster_player_unblocked: 'Jogador desbloqueado',
  roster_player_blocked: 'Jogador bloqueado',
  roster_action_error: 'Falha na ação',
  roster_no_players: 'Você ainda não tem jogadores. Toque em',
  roster_camera_title: 'Tirar foto com a câmera',
  roster_upload_gallery_title: 'Enviar da galeria',
  roster_camera_btn: 'Câmera',
  roster_upload_btn: 'Enviar',
  roster_photo_uploaded: 'Foto enviada',
  roster_photo_upload_error: 'Erro no envio da foto',
  roster_blocked_badge: 'Bloqueado',
  roster_block_btn: 'Bloquear',
  roster_unblock_btn: 'Reativar',
  roster_delete_title: 'Remover permanentemente',
  roster_block_title: 'Bloquear e tirar do time',
  roster_unblock_title: 'Desbloquear',
  roster_no_photo: 'SEM FOTO',
  roster_hand_right: 'Direita',
  roster_hand_left: 'Esquerda',
  roster_hand_ambi: 'Ambidestro',
  roster_hand_letter_right: 'D',
  roster_hand_letter_left: 'E',
  roster_hand_letter_ambi: 'A',
  roster_player_in_court: 'já está em quadra',
  roster_player_added_to_court: 'adicionado',
  admin_h1: 'Painel Admin',
  admin_tab_overview: 'Painel',
  admin_tab_users: 'Usuários',
  admin_tab_activity: 'Atividade',
  admin_coaches: 'Coaches',
  admin_players: 'Jogadores',
  admin_plays_global: 'Jogadas globais',
  admin_ai_sessions: 'Sessões IA',
  admin_top_plays: 'Top jogadas',
  admin_by_category: 'Por categoria',
  admin_col_name: 'Nome',
  admin_col_email: 'Email',
  admin_col_role: 'Função',
  admin_col_created: 'Criado',
  admin_delete_user_confirm: 'Excluir usuário?',
  admin_recent_activity: 'Atividade recente',
  sim_back_to_play: 'Voltar à jogada',
  sim_eyebrow: 'Simulador Tático',
  sim_subtitle: 'A IA simulará como a defesa reagiria e sugerirá ajustes concretos.',
  sim_rival_defense: 'Defesa rival',
  sim_exec_level: 'Nível de execução',
  sim_run_now: 'Simular agora',
  sim_running: 'Simulando...',
  sim_ai_prediction: 'Previsão IA',
  sim_confidence: 'Confiança:',
  sim_def_reaction: 'Como a defesa reagiria',
  sim_failure_points: 'Onde falharia',
  sim_adjustments: 'Ajustes recomendados',
  sim_key_player: 'Jogador #1:',
  tpl_modal_eyebrow: 'Modelos',
  tpl_modal_title: 'Comece com um sistema comprovado',
  tpl_modal_subtitle: 'Jogadas pré-carregadas com velocidades e delays calibrados. Ajuste a seu gosto.',
  tpl_steps_count: 'passos',
  diff_basic: 'Básico',
  diff_medium: 'Médio',
  diff_advanced: 'Avançado',
  editor_add_defenders: 'Adicionar defensores',
  editor_add_defenders_title: 'Colocar 5 defensores em formação homem-a-homem',
  editor_defenders_added: '5 defensores adicionados',
  editor_defenders_already: 'Defensores já estão em quadra',
  editor_remove_defenders: 'Remover defesa',
  editor_remove_defenders_title: 'Remover os 5 defensores deste passo',
  editor_defenders_removed: 'Defesa removida',
  enrich_play: '✨ Enriquecer narração',
  regenerate_enrichment: '✨ Regenerar narração',
  enriching: 'Enriquecendo...',
  enrichment_success: 'Jogada enriquecida — a voz e os textos agora são mais didáticos',
  enrichment_error: 'Erro ao enriquecer a jogada',
  enrichment_hint: 'A IA gera explicações mais longas e didáticas (O quê + Por quê + Pista chave) para cada passo. A narração lerá o texto enriquecido.',
  bulk_enrich_section_title: 'Enriquecimento em massa',
  bulk_enrich_section_body: 'Enriqueça TODAS as suas jogadas de uma vez no idioma atual. A IA gera narrações didáticas (O quê + Por quê + Pista chave). Executado em segundo plano — você pode fechar esta janela, o progresso é preservado.',
  bulk_enrich_btn: '🚀 Enriquecer todas as minhas jogadas',
  bulk_enrich_running: 'Enriquecendo',
  bulk_enrich_hint: 'Gera narrações enriquecidas para todas as suas jogadas no idioma atual.',
  bulk_enrich_force_label: 'Forçar regeneração (mesmo as já enriquecidas)',
  bulk_enrich_in_progress: 'Enriquecendo jogadas',
  bulk_enrich_done: 'Enriquecimento concluído!',
  bulk_enrich_done_title: 'Pronto',
  bulk_enrich_start_error: 'Falha ao iniciar o enriquecimento',
  bulk_enrich_completed: 'Concluídas',
  bulk_enrich_skipped: 'Ignoradas (já enriquecidas)',
  bulk_enrich_failed: 'Falhadas',
  bulk_enrich_current: 'Processando agora',
  bulk_enrich_errors: 'Erros',
  bulk_enrich_background_note: 'Isso pode demorar vários minutos dependendo do número de jogadas. Você pode fechar esta janela — o processo continua em segundo plano.',
};

export default dict;
